<template>
<ScreenLayout>

    <div class="pa-10 white ma-7 elevation-3" style="position:relative;xbackground-color:rgba(0,0,0,0.0)">
        <FormControl v-model="sampleRecord" :schema="sampleSchema" @change="formChanged" />
    </div>

    <div slot="right">
        
    </div>

</ScreenLayout>
</template>

<script>
import ScreenLayout from '@/screens/ScreenLayout'

import FormControl from './FormControl'

export default {
    name: 'Sample',
    props: {
        
    },
    components: {ScreenLayout, FormControl},
    data() {
        return {
            // selectedIndex: null,
 
            profile: null,

            sampleSchema: {
                name: 'mealOptions',
                fields: [
                    {
                        name: 'meal_name',
                        type: 'Text',
                        label: 'Meal Name'
                    },
                    {
                        name: 'meal_time',
                        type: 'Text',
                        label: 'Meal Start Time'
                    },
                    {
                        name: 'menu',
                        type: 'Group',
                        label: 'Menu Items',
                        fields: [
                            {
                                name: 'dish_name',
                                type: 'Text',
                                label: 'Dish',
                            },
                            {
                                name: 'menu_listing',
                                type: 'File',
                                label: 'Menu in PDF',
                                path: 'temp/sampleApp'
                            },
                            {
                                name: 'dish_ingredients',
                                type: 'Group',
                                label: 'Ingredients',
                                fields: [
                                    {
                                        name: 'ingredient_name',
                                        type: 'Text',
                                        label: 'Ingredient',
                                    },                                   
                                    {
                                        name: 'ingredient_availability',
                                        type: 'Switch',
                                        label: 'Available',
                                    },                                   
                                    {
                                        name: 'coming_soon',
                                        type: 'Checkbox',
                                        label: 'Coming Soon',
                                    },                                   
                                ]
                            }
                        ]
                    }
                ]
            },

            sampleRecord: {
                meal_name: 'Breakfast',
                meal_time: 'from 7am',
                menu: [
                    {
                        dish_name: 'Baked Beans',
                        dish_ingredients: [
                            {
                                ingredient_name: 'Beans',
                                ingredient_availability: true,
                                coming_soon: true,
                            },
                            {
                                ingredient_name: 'Sauce',
                                ingredient_availability: false,
                            },
                        ]
                    },
                    {
                        dish_name: 'Cereal'
                    },

                ]
            }
        }
    },
    computed:{

    },
    methods: {
        formChanged(newVal) {
            console.log('form changed', this.sampleRecord)
        }

    },

    created() {    

    },

    beforeDestroy() {
    
    }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>


// WEBPACK FOOTER //
// Sample.vue?5dc557d8